<template>
    <div class="activities">
      <div class="title">
        <div></div>
        兑换码列表
      </div>
      <div class="query">
      
    
        <div class="query-box">
        <el-select v-model="status" placeholder="请选择使用状态">
          <el-option label="全部" value="">全部</el-option>
          <el-option label="未使用" value="1">未使用</el-option>
          <el-option label="已使用" value="2">已使用</el-option>
        </el-select>
      </div>
  
        <el-button type="primary" @click="inquire">查询</el-button>
        <el-button type="warning" @click="derive">批量下载</el-button>
      </div>
      <div class="activities-main">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column align="center" type="index" label="序号" width="50">
          </el-table-column>
              <el-table-column align="center" prop="activityName" label="活动名称">
          </el-table-column>
          <el-table-column align="center" prop="code" label="兑换码">
          </el-table-column>
      
          <el-table-column align="center"  label="有效期">
            <template slot-scope="scope">
            {{ scope.row.startTime }}-{{ scope.row.endTime }}
          </template>
          </el-table-column>
           <el-table-column align="center" label="使用状态">
            <template slot-scope="scope">
            {{ scope.row.status==1?'未使用':'已使用' }}
          </template>
          </el-table-column>
  
          <el-table-column align="center" prop="usageTime" label="使用时间">
          </el-table-column>
               <el-table-column align="center" prop="addVipDays" label="增加会员有效时间天数">
          </el-table-column>
  
        
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paging">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[1, 3, 5, 10]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
   
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import local from "@/utils/local.js";
  import {  codePage ,functiondownload} from "@/api/api";
  import reg from "@/utils/reg.js";
  export default {
    data() {
      return {
        status: "",
        total: 0,
        currentPage: 1,
        pageSize: 10,
        tableData: [],
        activityId:'',
  
  
      
    
      };
    },
    created() {
      this.activityId=this.$route.query.activityId
      this.getList();
    },
    methods: {
           // 导出
    derive(){
       functiondownload('/admin/beer/code/data/select/excel',{ 
        id:this.activityId,
          status: this.status,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        
        },true)
    },
      //  获取活动列表
      async getList() {
        let res = await codePage({
          id:this.activityId,
          status: this.status,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
  
        });
        console.log(res);
        let { data } = res;
        //  边界判断
        if (!data.list.length && this.currentPage !== 1) {
          this.currentPage -= 1;
          this.getList();
        }
        this.tableData = data.list;
        this.total = data.total;
      },
  
      // 查询
      inquire() {
  
        this.getList();
      },
      // 刷新
      refresh() {
        this.status = "";
        this.getList();
      },
  
      //每页多少条
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
      },
      //当前多少页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .activities {
    // height: 100%;
    background: #fff;
    padding: 15px;
    color: #303133;
    .title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      div {
        width: 3px;
        height: 16px;
        background: #409eff;
        margin-right: 10px;
      }
    }
    .query {
      margin: 15px 0 30px;
      display: flex;
      align-items: center;
      .query-box {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .el-input {
          width: 260px;
        }
        span {
          width: 60px;
        }
      }
    }
    .activities-main {
      margin: 15px 0;
    }
    .paging {
      display: flex;
      justify-content: flex-end;
    }
  }
  .active {
    color: #33b959;
  }
  </style>